import { classNames } from 'primereact/utils';

export const ProgressSpinnerTailwindThemes = {
  global: {
    css: `
      .progress-spinner-circle {
          stroke-dasharray: 89, 200;
          stroke-dashoffset: 0;
          animation: p-progress-spinner-dash-fletchers 1.5s ease-in-out infinite, p-progress-spinner-color-fletchers 6s ease-in-out infinite;
          stroke-linecap: round;
      }

      @keyframes p-progress-spinner-dash-fletchers {
          0% {
              stroke-dasharray: 1, 200;
              stroke-dashoffset: 0;
          }
          
          50% {
              stroke-dasharray: 89, 200;
              stroke-dashoffset: -35px;
          }
          100% {
              stroke-dasharray: 89, 200;
              stroke-dashoffset: -124px;
          }
      }
      @keyframes p-progress-spinner-color-fletchers {
          100%, 0% {
              stroke: var(--color-fletchers-green-50);
          }
          40% {
              stroke: var(--color-fletchers-green-100);
          }
          66% {
              stroke: var(--color-fletchers-green-500);
          }
          80%, 90% {
              stroke: var(--color-fletchers-green-100);
          }
      }
  `
  },
  progressspinner: {
    root: {
      className: classNames('relative mx-auto w-28 h-28 inline-block', 'before:block before:pt-full')
    },
    spinner: 'absolute top-0 bottom-0 left-0 right-0 m-auto w-full h-full transform origin-center animate-spin',
    circle: 'text-red-500 progress-spinner-circle'
  }
};
